import { parseNavigationParams, parseProfessionalsListNavigationParams, QUERY_PARAM_TO_TAB } from '../utils/navigationHelpers.ts';

export type RouteKey =
  | 'dashboard'
  | 'peopleSearch'
  | 'projectDocCreate'
  | 'projectDocEdit'
  | 'productoCreate'
  | 'productoEdit'
  | 'marketplace'
  | 'marketplaceExplore'
  | 'workBag'
  | 'workBagExplore'
  | 'cotizacionesList'
  | 'cotizacionDetail'
  | 'cotizacionEdit'
  | 'cotizacionPostulante'
  | 'publicProjectsList'
  | 'publicProjectDetail'
  | 'obrasPrivadasExplore'
  | 'obrasPrivadasCreate'
  | 'obrasPrivadasDetail'
  | 'obrasPrivadasEdit'
  | 'costEstimation'
  | 'costEstimationDetail'
  | 'materialesCreate'
  | 'solicitudes'
  | 'usersList'
  | 'perfil'
  | 'workOffersInternal'
  | 'workOfferInternalDetail'
  | 'obraPublicaLicitar'
  | 'materialesALicitarPublicos'
  | 'proyectosAdjudicados'
  | 'faq'
  | 'obrasPrivadasList'
  | 'cotizaciondematerialesList'
  | 'backoffice';

export interface RouteNode {
  key: RouteKey;
  pattern: string;
  label: string | ((params: Record<string, string>) => string);
  suggestionPrompt?: string;
  parent?: RouteKey | ((params: Record<string, string>) => RouteKey | undefined);
}

export const routeConfig: RouteNode[] = [
  { key: 'dashboard', pattern: '/dashboard', label: 'Inicio' },
  { key: 'projectDocCreate', pattern: '/documentacion-de-obra/crear', label: 'Crear documentación de obra', suggestionPrompt: '¿Me guiás con la documentación de obra?', parent: 'dashboard' },
  { key: 'projectDocEdit', pattern: '/documentacion-de-obra/edit/:id', label: 'Editar documentación de obra', suggestionPrompt: '¿Me ayudás a editar esta documentación?', parent: 'dashboard' },
  { key: 'productoCreate', pattern: '/productos/crear', label: 'Crear producto o servicio', suggestionPrompt: '¿Me ayudás a publicar mi producto o servicio?', parent: 'dashboard' },
  { key: 'productoEdit', pattern: '/productos/edit/:id', label: 'Editar producto o servicio', suggestionPrompt: '¿Me ayudás a actualizar esta publicación?', parent: 'dashboard' },
  { key: 'marketplace', pattern: '/marketplace', label: 'Marketplace', parent: 'dashboard' },
  { key: 'marketplaceExplore', pattern: '/marketplace/explorar', label: 'Explorar marketplace', suggestionPrompt: '¿Me ayudás a explorar servicios y productos?', parent: 'dashboard' },
  { key: 'workBag', pattern: '/mercado-de-trabajo/crearoferta', label: 'Crear oferta de trabajo', suggestionPrompt: '¿Me ayudás a completar esta oferta de trabajo?', parent: 'dashboard' },
  { key: 'workOffersInternal', pattern: '/bolsa-trabajo', label: 'Bolsa de trabajo', suggestionPrompt: '¿Me ayudás a encontrar ofertas de trabajo para postularme?', parent: 'dashboard' },
  { key: 'workOfferInternalDetail', pattern: '/bolsa-trabajo/:id', label: 'Detalle de oferta', parent: 'workOffersInternal' },

  { key: 'costEstimation', pattern: '/cotizaciondemateriales/estimacion-costos', label: 'Estimación de costos', suggestionPrompt: '¿Me ayudás con la estimación de costos de materiales?', parent: 'dashboard' },
  { key: 'materialesCreate', pattern: '/cotizaciondemateriales/crear', label: 'Crear cotización de materiales', suggestionPrompt: '¿Me ayudás a armar la solicitud de cotización de materiales?', parent: 'dashboard' },
  { key: 'cotizacionesList', pattern: '/cotizaciondemateriales/explorar', label: 'Explorar cotizaciones de materiales', suggestionPrompt: '¿Me ayudás a encontrar cotizaciones disponibles?', parent: 'dashboard' },
  { key: 'cotizacionPostulante', pattern: '/cotizaciondemateriales/postulante/:quotationId', label: 'Cotizar materiales', suggestionPrompt: '¿Me guiás para enviar mi cotización de materiales?', parent: 'cotizacionesList' },
  { key: 'cotizacionEdit', pattern: '/cotizaciondemateriales/edit/:id', label: 'Editar cotización de materiales', suggestionPrompt: '¿Me ayudás a editar esta cotización?', parent: 'cotizacionesList' },
  { key: 'cotizacionDetail', pattern: '/cotizaciondemateriales/:id', label: 'Detalle de cotización', parent: 'cotizacionesList' },
  { key: 'publicProjectDetail', pattern: '/proyecto/:id', label: 'Detalle de proyecto', parent: 'dashboard' },
  { key: 'obrasPrivadasExplore', pattern: '/obrasprivadas/explorar', label: 'Cotizar en obras', suggestionPrompt: '¿Me ayudás a cotizar en obras privadas?', parent: 'dashboard' },
  { key: 'obrasPrivadasCreate', pattern: '/obrasprivadas/crear', label: 'Crear obra privada', suggestionPrompt: '¿Me guiás para publicar mi obra y recibir presupuestos?', parent: 'dashboard' },
  { key: 'obrasPrivadasEdit', pattern: '/obrasprivadas/edit/:id', label: 'Editar obra privada', suggestionPrompt: '¿Me ayudás a actualizar esta obra?', parent: 'dashboard' },
  { key: 'obrasPrivadasDetail', pattern: '/obrasprivadas/:id', label: 'Detalle de obra privada', parent: 'dashboard' },
  { key: 'solicitudes', pattern: '/notificaciones', label: 'Notificaciones', parent: 'dashboard' },
  { key: 'perfil', pattern: '/perfil/:id', label: 'Perfil', parent: 'dashboard' },
  { key: 'publicProjectsList', pattern: '/obraspublicas', label: 'Obras públicas', suggestionPrompt: '¿Me ayudás a explorar licitaciones y obras públicas?', parent: 'dashboard' },
  { key: 'usersList', pattern: '/buscar-perfiles', label: 'Explorar perfiles', suggestionPrompt: '¿Me ayudás a buscar profesionales o empresas?', parent: 'dashboard' },
  { key: 'obraPublicaLicitar', pattern: '/obra-publica-a-licitar/:id', label: 'Obra pública a licitar', parent: 'dashboard' },
  { key: 'materialesALicitarPublicos', pattern: '/materiales-a-licitar-publicos/:id', label: 'Materiales a licitar', parent: 'dashboard' },
  { key: 'proyectosAdjudicados', pattern: '/obraspublicas/proyectos-adjudicados/:id', label: 'Proyecto adjudicado', parent: 'publicProjectsList' },
  { key: 'faq', pattern: '/faq', label: 'Ayuda', parent: 'dashboard' },
  { key: 'obrasPrivadasList', pattern: '/obrasprivadas', label: 'Mis obras privadas', parent: 'dashboard' },
  { key: 'cotizaciondematerialesList', pattern: '/cotizaciondemateriales', label: 'Cotizaciones de materiales', parent: 'dashboard' },
  { key: 'backoffice', pattern: '/backoffice', label: 'Backoffice', parent: 'dashboard' },
];

export const matchRoute = (pathname: string): { node: RouteNode; params: Record<string, string> }[] => {
  const segments = pathname.split('/').filter(Boolean);
  const matches: { node: RouteNode; params: Record<string, string> }[] = [];
  for (const node of routeConfig) {
    const patSegs = node.pattern.split('/').filter(Boolean);
    if (patSegs.length !== segments.length) continue;
    const params: Record<string, string> = {};
    let ok = true;
    for (let i = 0; i < patSegs.length; i++) {
      const p = patSegs[i];
      const seg = segments[i];
      if (p.startsWith(':')) {
        params[p.slice(1)] = seg;
        continue;
      }
      if (p !== seg) {
        ok = false;
        break;
      }
    }
    if (ok) matches.push({ node, params });
  }
  if (matches.length) return matches;
  const roots = routeConfig.filter(r => r.pattern === '/dashboard');
  return roots.map(r => ({ node: r, params: {} }));
};

export function getRouteLabel(node: RouteNode, params: Record<string, string>): string {
  return typeof node.label === 'string' ? node.label : node.label(params);
}

export const getParentForRoute = (
  node: RouteNode,
  pathname: string,
  searchParams: URLSearchParams
): RouteKey | undefined => {
  const navParams = parseNavigationParams(searchParams);
  const professionalsNav = parseProfessionalsListNavigationParams(searchParams);
  
  if (typeof node.parent === 'function') {
    const params: Record<string, string> = {};
    const segments = pathname.split('/').filter(Boolean);
    const patSegs = node.pattern.split('/').filter(Boolean);
    for (let i = 0; i < patSegs.length; i++) {
      const p = patSegs[i];
      if (p.startsWith(':')) {
        params[p.slice(1)] = segments[i];
      }
    }
    return node.parent(params);
  }

  if (professionalsNav && node.key === 'perfil') {
    return 'usersList';
  }

  if (navParams && navParams.from === 'perfil') {
    return 'perfil';
  }

  return node.parent;
};

export const getProfileBreadcrumbLabel = (searchParams: URLSearchParams): string => {
  const navParams = parseNavigationParams(searchParams);
  if (navParams && navParams.tab) {
    const tabName = QUERY_PARAM_TO_TAB[navParams.tab] || 'Perfil';
    return `${tabName} - Perfil`;
  }
  const tabParam = searchParams.get('tab');
  if (tabParam && QUERY_PARAM_TO_TAB[tabParam as keyof typeof QUERY_PARAM_TO_TAB]) {
    const tabName = QUERY_PARAM_TO_TAB[tabParam as keyof typeof QUERY_PARAM_TO_TAB];
    return `${tabName} - Perfil`;
  }
  return 'Perfil';
};


